import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

const testimonials = [
  {
    text: "“Platinum24 Cabs made my airport transfer from Pune to Mumbai absolutely stress-free. The car was spotless, the driver was punctual and professional.”",
    rating: 5,
    name: "Mr. Rajesh Sharma",
    role: "Frequent Business Traveler, Platinum24 Cabs",
   
  },
  {
    text: "“I booked a weekend trip to Lonavala through Platinum24 Cabs and had a wonderful experience. The ride was smooth, and the service was top-notch!”",
    rating: 5,
    name: "Miss. Priya Singh",
    role: "Weekend Explorer, Platinum24 Cabs",
    
  },
  {
    text: "“From the booking process to drop-off in Goa, everything was seamless. Platinum24 Cabs truly offers comfort and convenience for long-distance trips.”",
    rating: 5,
    name: "Miss. Anjali Patel",
    role: "Vacation Traveler, Platinum24 Cabs",
    
  },
];


const TestimonialSection = () => {
  return (
    <section
      className="space testimonial-style2"
      style={{ backgroundImage: "url('/img/bg/testimonial-bg-2.jpg')" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <div className="title-area white-title">
              <span className="sec-subtitle">Our Best Review’s</span>
              <h2 className="sec-title h1"> Happy Clients </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={2}
            loop={true}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 2 },
            }}
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="col-xl-12">
                  <div className="testi-style2">
                    <div className="testi-body">
                      <p className="testi-text">{testimonial.text}</p>
                      <div className="testi-rating">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className={
                              i < testimonial.rating ? 'fas fa-star' : 'far fa-star'
                            }
                          ></i>
                        ))}
                      </div>
                    </div>
                    <h3 className="testi-name">{testimonial.name}</h3>
                    <span className="testi-degi">{testimonial.role}</span>
                    <div className="testi-avater">
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
